<template>
    <div class="report-result">
        <!-- 1、基础数据 -->
        <div class="report-result-content">
            <div class="report-result-title">性格解析</div>
            <div class="report-result-main-content">
                <p class="report-p-red">本项测试如果基本相符，说明AI智能程序运算正确，可以继续后面的内容，否则可以无视本次测评。</p>
                <div v-if="reportData[productList[0]] == 0" class="report-result-content-fuzzy-1">
                    <div v-if="productData[productList[0]]" class="report-result-button report-result-button-posab">
                        <div v-if="aiConfigData.freeTimes > 0" class="report-result-note">您有<span class="number">{{aiConfigData.freeTimes}}</span>张性格测评免费解锁券</div>
                        <report-button
                            v-bind:buttonType="'2'"
                            v-bind:reportData="productData[productList[0]]"
                            v-bind:freeBtn="aiConfigData.freeTimes > 0"
                            v-bind:clickFunc="clickPay">
                        </report-button>
                        <p class="report-result-button-note note-red">专属优惠价，原价<del>{{productData[productList[0]].rate_price}}</del>元 已有{{basicProductData[productList[0]].sold}}人购买</p>
                    </div>
                </div>
                <div v-else>
                    <p v-for="describeData in reportAIData.describe" v-bind:key="describeData + Math.random(0, 10)">{{describeData}}</p>
                </div>
            </div>
        </div>

        <!-- 6.1 解锁按钮:解锁全部:5 -->
        <!-- 全部都解锁之后隐藏按钮 -->
        <div class="report-result-button" v-if="(reportData[productList[1]] == 0 || reportData[productList[2]] == 0 || reportData[productList[3]] == 0 || reportData[productList[4]] == 0) && reportData[productList[5]] == 0 && productData[productList[5]]">
            <report-button 
                v-bind:buttonType="'1'"
                v-bind:buttonText="'解锁以下所有报告'"
                v-bind:reportData="productData[productList[5]]"
                v-bind:clickFunc="clickPay">
            </report-button>
            <p class="report-result-button-note">专属优惠价，原价<del>{{productData[productList[5]].rate_price}}</del>元 已有{{basicProductData[productList[5]].sold}}人购买</p>
        </div>

        <!-- 3、提升人生财富水平的建议 -->
        <div class="report-result-content">
            <div class="report-result-title">提升人生财富水平的建议</div>
            <p class="report-p-red">越想赚钱的人越赚不到钱，越不想赚钱的人越赚得到钱，我该怎么办？</p>
            <!-- 6.3 解锁按钮:解锁建议:2 -->
            <div v-if="reportData[productList[2]] == 0" class="report-result-content-fuzzy-2">
                <div v-if="productData[productList[2]]" class="report-result-button report-result-button-posab">
                    <report-button
                        v-bind:buttonType="'2'"
                        v-bind:reportData="productData[productList[2]]"
                        v-bind:clickFunc="clickPay">
                    </report-button>
                    <p class="report-result-button-note note-red">专属优惠价，原价<del>{{productData[productList[2]].rate_price}}</del>元 已有{{basicProductData[productList[2]].sold}}人购买</p>
                </div>
            </div>
            <div v-if="reportData[productList[2]] == -1" class="report-result-content-no-result">
                <p>出生时间超出智能测算时间范围，</p>
                <p>不能进行此项测算。</p>
            </div>
            <div v-else class="report-result-ct-content">
                <p v-for="suggestData in reportAIData.suggest" v-bind:key="suggestData + Math.random(0, 10)"  class="">{{suggestData}}</p>
            </div>
        </div>

        <!-- 2、2020年近12个月财运趋势 -->
        <div class="report-result-content">
            <div class="report-result-title">2020年按月个人运势</div>
            <div class="report-result-sub-title">
                <span>未来12个月财运趋势</span>
            </div>
            <!-- 6.2 解锁按钮:解锁12个月财运:1 -->
            <div v-if="reportData[productList[1]] == 0" class="report-result-content-fuzzy-3">
                <div v-if="productData[productList[1]]" class="report-result-button report-result-button-posab">
                    <report-button
                        v-bind:buttonType="'2'"
                        v-bind:reportData="productData[productList[1]]"
                        v-bind:clickFunc="clickPay">
                    </report-button>
                    <p class="report-result-button-note note-red">专属优惠价，原价<del>{{productData[productList[1]].rate_price}}</del>元 已有{{basicProductData[productList[1]].sold}}人购买</p>
                </div>
            </div>
            <div v-if="reportData[productList[1]] == -1" class="report-result-content-no-result">
                <p>出生时间超出智能测算时间范围，</p>
                <p>不能进行此项测算。</p>
            </div>
            <!-- 数据表 -->
            <report-data-area v-if="reportAIData.month && reportAIData.month.x && reportAIData.month.y" 
                v-bind:canvasId="'dataAreaMonth'"
                v-bind:xTitle="monthXTitle"
                v-bind:xDataArr="reportAIData.month.x"
                v-bind:yDataArr="reportAIData.month.y">
            </report-data-area>
            <div v-if="reportAIData.month && reportAIData.month.msg" class="report-result-detail">
                <p>{{reportAIData.month.msg}}</p>
                <p>其中<span class="report-p-red">{{reportAIData.month.maxTips}}月</span>将是未来12个月中财运最好的月份，务必抓住机会哦。<span v-if="reportAIData.month.max">其中财运最旺在<span class="report-p-red">{{reportAIData.month.max}}</span>月发生。</span> 要提升财运把握能力，请看前面的提升建议。</p>
                
                <p class="report-p-red">以上智能测算结果仅供参考，无论财运如何，投资决策都须谨慎！财运好的时候也需要自己努力争取，谨慎决策，重要的事情说多遍！</p>
            </div>
        </div>

        <!-- 4、未来五年财运趋势 -->
        <div class="report-result-content">
            <div class="report-result-title">未来五年个人运势</div>
            <!-- 6.4 解锁按钮:解锁未来五年财运趋势:3 -->
            <div v-if="reportData[productList[3]] == 0" class="report-result-content-fuzzy-4">
                <div v-if="productData[productList[3]]" class="report-result-button report-result-button-posab">
                    <report-button
                        v-bind:buttonType="'2'"
                        v-bind:reportData="productData[productList[3]]"
                        v-bind:clickFunc="clickPay">
                    </report-button>
                    <p class="report-result-button-note note-red">专属优惠价，原价<del>{{productData[productList[3]].rate_price}}</del>元 已有{{basicProductData[productList[3]].sold}}人购买</p>
                </div>
            </div>
            <div v-if="reportData[productList[3]] == -1" class="report-result-content-no-result">
                <p>出生时间超出智能测算时间范围，</p>
                <p>不能进行此项测算。</p>
            </div>
            <!-- 数据表 -->
            <report-data-area v-if="reportAIData.five && reportAIData.five.x && reportAIData.five.y"
                v-bind:canvasId="'dataAreaFive'"
                v-bind:xTitle="fiveXTitle"
                v-bind:xDataArr="reportAIData.five.x"
                v-bind:yDataArr="reportAIData.five.y">
            </report-data-area>
            <div v-if="reportAIData.five" class="report-result-detail">
                <p v-for="(fiveData, key) in reportAIData.five.msg" v-bind:key="key + Math.random(0, 10)"  class=""><span class="report-p-red">{{key + '年：'}}</span>{{fiveData}}</p>
            </div>
        </div>

        <!-- 5、人生财运总趋势 -->
        <div class="report-result-content">
            <div class="report-result-title">人生运程总趋势</div>
            <!-- 6.5 解锁按钮:解锁人生财运总趋势:4 -->
            <div v-if="reportData[productList[4]] == 0" class="report-result-content-fuzzy-5">
                <div v-if="productData[productList[4]]" class="report-result-button report-result-button-posab">
                    <report-button
                        v-bind:buttonType="'2'"
                        v-bind:reportData="productData[productList[4]]"
                        v-bind:clickFunc="clickPay">
                    </report-button>
                    <p class="report-result-button-note note-red">专属优惠价，原价<del>{{productData[productList[4]].rate_price}}</del>元 已有{{basicProductData[productList[4]].sold}}人购买</p>
                </div>
            </div>
            <div v-if="reportData[productList[4]] == -1" class="report-result-content-no-result">
                <p>出生时间超出智能测算时间范围，</p>
                <p>不能进行此项测算。</p>
            </div>
            <!-- 数据表 -->
            <report-data-area v-if="reportAIData.all && reportAIData.all.x && reportAIData.all.y"
                v-bind:canvasId="'dataAreaAll'"
                v-bind:xTitle="allXTitle"
                v-bind:xDataArr="reportAIData.all.x"
                v-bind:yDataArr="reportAIData.all.y">
            </report-data-area>
            <div v-if="reportAIData.all" class="report-result-detail">
                <p v-for="(allData, key) in reportAIData.all.msg" v-bind:key="key + Math.random(0, 10)"  class=""><span class="report-p-red">{{key + '年：'}}</span>{{allData}}</p>
            </div>
        </div>

        <!-- 6、提示解锁成功的弹框 -->
        <van-popup class="report-result-suc" v-bind:value="showPaySuc" @click-overlay="clickPayPop">
            <div class="report-result-suc-content">
                <img v-bind:src="sucGif" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { API } from '../../modules/api'
import { WEIXIN_PAY } from '../../modules/weixin'
import ReportButton from './ReportButton.vue'
import ReportDataArea from './ReportDataArea.vue'
import { SCHEME } from '../../modules/utils'
import { CONFIG } from '../../modules/config'
export default {
    name: 'ReportResult',
    components: { ReportButton, ReportDataArea },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        aiConfigData() {
            return this.$store.state.report.aiConfigData;
        },
        basicProductData() {
            return this.$store.state.report.aiConfigData.product;
        },
        productList() {
            return this.$store.state.report.productList;
        },
        productData() {
            return this.$store.state.report.productData;
        },
        reportData() {
            return this.$store.state.report.reportData;
        },
        reportAIData() {
            return this.$store.state.report.reportAIData;
        }
    },
    data() {
        return {
            monthXTitle: '(月)',
            fiveXTitle: '(年)',
            allXTitle: '(年)',
            monthXData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            monthYData: [130, 100, 150, 130, 150, 130, 100, 150, 130, 150, 100, 120],
            fiveXData: [2020, 2021, 2022, 2023, 2024],
            fiveYData: [130, 100, 150, 130, 150],
            allXData: [2020, 2030, 2040, 2050, 2060],
            allYData: [130, 100, 150, 130, 150],
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif')
        }
    },
    methods: {
        clickPay(params) {
            var me = this,
                reportId = this.reportData.id,
                detailInfo = this.$store.state.report.detailInfo;
            console.log('clickPay--------', params.free, params.data, reportId, detailInfo.id, this.fromEmbedded)

            // 免费解锁性格
            if(params.free && this.aiConfigData.freeTimes > 0) {
                this.$store.dispatch('report/useReportFree', {
                    id: detailInfo.id,
                    cb: params.cb ? params.cb : null
                });
                return;
            }

            if(this.fromEmbedded) {
                SCHEME.createAppOrder(params.data.pid, detailInfo.id);
                window.appFunc = {};
                window.appFunc.reportPaySucCb = function(data) {
                    console.log('reportPaySucCb::::::::', data)
                    // data = JSON.stringify(data);
                    if(detailInfo) {
                        me.$store.dispatch('report/updateReportInfo', data.baziId);
                    }

                    // 显示并定时隐藏支付成功提示
                    me.showPaySuc = true;
                    setTimeout(() => {
                        me.showPaySuc = false;
                    }, 3000);

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
                window.appFunc.reportPayFailCb = function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
                return;
            }

            // 手动设置微信扫码支付的ptype值
            var payType = CONFIG.platform == 'web' ? 'wx_qr' : params.data.payType[2];

            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: payType,     //支付方式
                    ext: detailInfo.id                 //支付的评测id
                },
                sucCb: function() {
                    console.log('支付成功，更新测评报告数据');
                    // 更新测验报告数据
                    if(detailInfo) {
                        me.$store.dispatch('report/updateReportInfo', detailInfo.id);
                    }
                    // 更新ai状态
                    me.$store.state.detail.personInfo.ai = 1;
                    me.$store.dispatch('record/updateRecordListAIStatus', {
                        id: detailInfo.id
                    });

                    // 显示并定时隐藏支付成功提示
                    me.showPaySuc = true;
                    setTimeout(() => {
                        me.showPaySuc = false;
                    }, 3000);

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        },
        clickPayPop() {
            this.showPaySuc = false;
        }
    }
}
</script>